import React, { useState } from "react";
import "../../App.css";

interface Print {
  title: string;
  src: string;
  orientation: "portrait" | "landscape";
}

const prints: Print[] = [
  { title: "Soba Den", src: "/images/printshop/Noodle-Stop.jpg", orientation: "portrait" },
  { title: "Kyoto Geisha", src: "/images/printshop/Kyoto-Lady.jpg", orientation: "portrait" },
  { title: "Harley", src: "/images/printshop/Harley.jpg", orientation: "portrait" },
  { title: "Business Time", src: "/images/printshop/Business time.jpg", orientation: "landscape" },
  { title: "Station Queue", src: "/images/printshop/Station-Queue.jpg", orientation: "portrait" },
  { title: "Hotdog Street", src: "/images/printshop/Hotdog street.jpg", orientation: "portrait" },
  { title: "Whtie Shoes", src: "/images/printshop/Shoes.jpg", orientation: "landscape" },
  { title: "Vending", src: "/images/printshop/Vending-Port.jpg", orientation: "portrait" },
];

export function PrintShop(): JSX.Element {
  const [selectedPrint, setSelectedPrint] = useState<Print>(prints[0]);

  return (
    <main className="print-shop">
      <header className="print-shop-intro">
        <p className="print-shop-kicker">The Japan collection</p>
        <h1>Print shop</h1>
        <p className="print-shop-description">
          All the images are available as 8 x 10 inch prints on
          Hahnemühle Photo Rag paper for £40 (including free UK shipping) and shipped within
          two weeks of payment.
        </p>
        <p className="print-shop-description">
          To place an order, get in touch directly via{" "}
          <a href="mailto:hello@mattfeeneyphotography.co.uk">email</a> or send me
          a message on{" "}
          <a
            href="https://www.instagram.com/matt__feeney/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Instagram
          </a>
          . I’m happy to help with any questions or specific requests.
        </p>
      </header>

      <section className="print-shop-feature" aria-live="polite">
        <div className="print-shop-hero">
          <div className={`print-shop-frame is-${selectedPrint.orientation}`}>
            <div
              className={`print-shop-image is-${selectedPrint.orientation}`}
              role="img"
              aria-label={selectedPrint.title}
              onContextMenu={(event) => event.preventDefault()}
              style={{ backgroundImage: `url("${selectedPrint.src}")` }}
            />
          </div>
        </div>
        <div className="print-shop-caption">
          <span>{selectedPrint.title}</span>
          <span>£40 · Free UK shipping</span>
        </div>
      </section>

      <section className="print-shop-selection" aria-labelledby="print-selection-title">
        <div className="print-shop-selection-heading">
          <h2 id="print-selection-title">Select a print</h2>
          <span>{prints.length} photographs</span>
        </div>

        <div className="print-shop-grid">
          {prints.map((print) => {
            const isSelected = print.src === selectedPrint.src;

            return (
              <button
                key={print.src}
                className={`print-shop-thumbnail${isSelected ? " is-selected" : ""}`}
                type="button"
                aria-label={`View ${print.title}`}
                aria-pressed={isSelected}
                onClick={() => setSelectedPrint(print)}
              >
                <div
                  className="print-shop-thumbnail-image"
                  aria-hidden="true"
                  onContextMenu={(event) => event.preventDefault()}
                  style={{ backgroundImage: `url("${print.src}")` }}
                />
                <span>{print.title}</span>
              </button>
            );
          })}
        </div>
      </section>

      <section className="print-shop-enquiry">
        <p>Interested in a print?</p>
        <h2>Order {selectedPrint.title} for £40.</h2>
        <div className="print-shop-enquiry-links">
          <a href={`mailto:hello@mattfeeneyphotography.co.uk?subject=Print order: ${selectedPrint.title}`}>
            Order by email
          </a>
          <a
            href="https://www.instagram.com/matt__feeney/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Order via Instagram
          </a>
        </div>
      </section>
    </main>
  );
}
